module.exports = __webpack_public_path__ + "static/gallery-15-1e11a0af6a84878a929b0b61c4f34700.jpg";